// src/components/affiliate/CoupangDynamicBanner.tsx
import React, { useEffect, useRef } from 'react';
import { CoupangBannerSpec, COUPANG_TRACKING_CODE } from '../../config/coupang';

/**
 * 쿠팡 파트너스 다이나믹 배너(스크립트 위젯) 한 개.
 *
 * 파트너스가 주는 코드는 <script> 두 개를 그 자리에 넣는 방식이라 React 와
 * 궁합이 나쁩니다. 그래서 빈 컨테이너를 만들고 그 안에 스크립트를 주입해
 * 위젯이 컨테이너 안에 그려지도록 합니다.
 *
 * - 프리렌더링(renderToString)에서는 빈 컨테이너만 출력되므로 빌드에 영향 없음
 * - 라우트 이동 시 위젯이 쌓이지 않도록 언마운트에서 내용을 비웁니다
 */
const CoupangDynamicBanner: React.FC<{ banner: CoupangBannerSpec }> = ({ banner }) => {
    const boxRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const box = boxRef.current;
        if (!box || banner.id <= 0 || !COUPANG_TRACKING_CODE) return;

        const loader = document.createElement('script');
        loader.src = 'https://ads-partners.coupang.com/g.js';
        loader.async = true;
        loader.onload = () => {
            // g.js 가 로드된 뒤에야 PartnersCoupang 전역이 생깁니다.
            const init = document.createElement('script');
            init.text = `new PartnersCoupang.G(${JSON.stringify({
                id: banner.id,
                template: banner.template,
                trackingCode: COUPANG_TRACKING_CODE,
                width: banner.width,
                height: banner.height,
            })});`;
            box.appendChild(init);
        };
        box.appendChild(loader);

        return () => {
            box.innerHTML = '';
        };
    }, [banner]);

    return (
        <div
            ref={boxRef}
            className="gh-cpang-banner__box"
            style={{ maxWidth: `${banner.width}px`, minHeight: `${banner.height}px` }}
        />
    );
};

export default CoupangDynamicBanner;
